"use strict";

exports.__esModule = true;
exports.DurationRangeSelector = DurationRangeSelector;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Utils = require("../../../Utils");
var _DropdownCheckboxList = require("../DropdownCheckboxList");
var _excluded = ["items"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.name;
}
function itemPredicate(query, item) {
  return !!item.name.match(new RegExp((0, _Utils.escapeRegExp)(query), "gi"));
}

/**
 * Allows a user to select duration range from a list.
 */
function DurationRangeSelector(_ref) {
  var items = _ref.items,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_DropdownCheckboxList.DropdownCheckboxList, _extends({
    placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DurationRangeSelector.placeholder",
      defaultMessage: "Duration"
    }),
    getKey: getKey,
    renderItemText: renderItemText,
    itemPredicate: itemPredicate,
    items: items
  }, extra));
}